import { useTranslation } from 'react-i18next';
import pageStyles from './LogisticsPage.module.css';
import styles from './LogisticsSkeleton.module.css';

/** The KPI row's four tiles and the board's three default columns. */
const KPI_TILES = 4;
const BOARD_COLUMNS = 3;

/**
 * The page's loading state, in the page's own layout — header, KPI row, the
 * Materials segment (board, then inventory beside waste) and the site map —
 * so the swap to the loaded page is a fade, not a blank canvas followed by a
 * reflow. Same frame as the page (`.page`, `.segment`, `.row`), same shimmer
 * as the dashboard's skeleton.
 */
export function LogisticsSkeleton() {
  const { t } = useTranslation();
  return (
    <div
      className={pageStyles.page}
      aria-busy="true"
      aria-label={t('logistics.loading')}
      data-testid="logistics-loading"
    >
      <div className={styles.kpis}>
        {Array.from({ length: KPI_TILES }, (_, i) => (
          <span key={i} className={`${styles.shimmer} ${styles.tile}`} />
        ))}
      </div>
      <section className={pageStyles.segment}>
        <span className={`${styles.shimmer} ${styles.line}`} />
        <div className={styles.board}>
          {Array.from({ length: BOARD_COLUMNS }, (_, i) => (
            <span key={i} className={`${styles.shimmer} ${styles.column}`} />
          ))}
        </div>
        <div className={pageStyles.row}>
          <span className={`${styles.shimmer} ${styles.panel}`} />
          <span className={`${styles.shimmer} ${styles.panel}`} />
        </div>
      </section>
      <span className={`${styles.shimmer} ${styles.map}`} />
    </div>
  );
}
